module.exports = __webpack_public_path__ + "static/media/climatec.f1465e6d.webp";